<template>
  <div class="gap-general var-style">
    <SmallBanner
      :icon="'article'"
      :title="$t('order-types.title')"
      :description="$t('order-types.description')"
    />
    <div class="margin-general find_forex margin-less">
      <p class="body-4 d-sm">{{ $t("order-types.label") }}</p>
      <tabsAccordeons
        :tabs="tabs"
        :categories="categories"
        :showIframe="true"
        class="grid-special"
      />
    </div>

    <client-only>
      <LazyInvestment
        class="investment var-invest-two"
        :label="'forex-contract-specs.ready'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'forex-contract-specs.btn'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import SmallBanner from "~/components/SmallBanner.vue";
import tabsAccordeons from "~/components/tabs-accordeons.vue";

import { useI18n } from "vue-i18n";
const { getExternalUrl } = useExternalUrl();
const { t } = useI18n();
const title = t("seo.trading-conditions.order-types.title");
const description = t("seo.trading-conditions.order-types.description");

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
});

let tabs = ref([
  { value: "forex", label: "order-types.labeltab1" },
  { value: "stocks", label: "order-types.labeltab2" },
  // { value: "futures", label: "order-types.labeltab3" },
]);

let categories = ref({
  forex: [
    {
      subTabs: [
        {
          value: "Market orders forex",
          label: "order-types.label-subtab1",
          items: [
            {
              icon: "keyboard_tab",
              title: "order-types.titleCard1",
              text: "order-types.descripitCard1",
              specialClass: "icon-buy",
            },
            {
              icon: "keyboard_tab",
              title: "order-types.titleCard2",
              text: "order-types.descripitCard2",
              specialClass: "icon-sell",
            },
          ],
        },
        {
          value: "Pending orders forex",
          label: "order-types.label-subtab2",
          items: [
            {
              icon: "fit_width",
              title: "order-types.titleCard3",
              text: "order-types.descripitCard3",
            },
            {
              icon: "block",
              title: "order-types.titleCard4",
              text: "order-types.descripitCard4",
            },
            {
              icon: "fit_width",
              title: "order-types.titleCard5",
              text: "order-types.descripitCard5",
            },
            {
              icon: "block",
              title: "order-types.titleCard6",
              text: "order-types.descripitCard6",
            },
          ],
        },
      ],
    },
  ],
  stocks: [
    {
      subTabs: [
        {
          value: "Market orders stocks",
          label: "order-types.label-subtab1",
          items: [
            {
              icon: "keyboard_tab",
              title: "order-types.titleCard1",
              text: "order-types.descripitCard7",
              specialClass: "icon-buy",
            },
            {
              icon: "keyboard_tab",
              title: "order-types.titleCard2",
              text: "order-types.descripitCard2",
              specialClass: "icon-sell",
            },
          ],
        },
        {
          value: "Pending orders stocks",
          label: "order-types.label-subtab2",
          items: [
            {
              icon: "fit_width",
              title: "order-types.titleCard3",
              text: "order-types.descripitCard3",
            },
            {
              icon: "block",
              title: "order-types.titleCard4",
              text: "order-types.descripitCard4",
            },
            {
              icon: "fit_width",
              title: "order-types.titleCard5",
              text: "order-types.descripitCard5",
            },
            {
              icon: "block",
              title: "order-types.titleCard6",
              text: "order-types.descripitCard6",
            },
          ],
        },
      ],
    },
  ],
  futures: [
    {
      subTabs: [
        {
          value: "Market orders futures",
          label: "order-types.label-subtab1",
          items: [
            {
              icon: "keyboard_tab",
              title: "order-types.titleCard1",
              text: "order-types.descripitCard7",
              specialClass: "icon-buy",
            },
            {
              icon: "keyboard_tab",
              title: "order-types.titleCard2",
              text: "order-types.descripitCard2",
              specialClass: "icon-sell",
            },
          ],
        },
        {
          value: "Pending orders futures",
          label: "order-types.label-subtab2",
          items: [
            {
              icon: "fit_width",
              title: "order-types.titleCard3",
              text: "order-types.descripitCard3",
            },
            {
              icon: "block",
              title: "order-types.titleCard4",
              text: "order-types.descripitCard4",
            },
            {
              icon: "fit_width",
              title: "order-types.titleCard5",
              text: "order-types.descripitCard5",
            },
            {
              icon: "block",
              title: "order-types.titleCard6",
              text: "order-types.descripitCard6",
            },
            {
              icon: "price_check",
              title: "order-types.titleCard8",
              text: "order-types.descripitCard8",
            },
            {
              icon: "line_start",
              title: "order-types.titleCard9",
              text: "order-types.descripitCard9",
            },
            {
              icon: "line_end",
              title: "order-types.titleCard10",
              text: "order-types.descripitCard10",
            },
            {
              icon: "calendar_clock",
              title: "order-types.titleCard11",
              text: "order-types.descripitCard11",
            },
          ],
        },
      ],
      showIframe: true,
      iframeOptions: {
        src: "https://ibportal.gainfutures.com/TradingHours?WLID=358",
        width: "100%",
        height: "1605vh",
        frameborder: "0",
        allowfullscreen: true,
      },
    },
  ],
});
</script>
